import {useContext} from 'react';
import EzManageNavContext from './EzManageNavContext';

const useEzManageNavContext = () => useContext(EzManageNavContext);

export default useEzManageNavContext;
